import React from 'react';

import Screen from '../components/Screen';
import ErrorScreen from './ErrorScreen';

export default function NotFoundScreen() {
  return(
    <Screen title="Page Not Found" showTitle={false} >
      <ErrorScreen />
    </Screen>
  );
}